import React from 'react';

const RefundPolicy = () => {
  return (
    <section className="bg-white py-12 px-6 max-w-4xl mx-auto text-gray-800">
      <h1 className="text-3xl font-bold mb-6 mt-8">Refund Policy</h1>
      <p className="mb-4">Effective Date: 01/01/2025</p>
      <p className="mb-6">At Racila Softech Pvt. Ltd., we aim to deliver dependable and high-quality website development and digital services. However, we understand that certain situations may require a refund. Please read this policy carefully before making a purchase.</p>

      <h2 className="text-xl font-semibold mt-8 mb-2">1. Complete Refund for Customer Business Closure</h2>
      <p className="mb-4">If the customer closes their business before signing the Customer Requirement Document (CRD), they will receive a 100% refund, provided they submit legitimate documentation confirming the closure.</p>

      <h2 className="text-xl font-semibold mt-8 mb-2">2. 70% Refund for Project Dissatisfaction</h2>
      <p className="mb-4">Customers are entitled to a 70% refund of the total project cost if they express dissatisfaction at any point before project handover. Dissatisfaction must be formally recorded and shared with the company for internal review. The decision of our management team will be final and legally binding.</p>

      <h2 className="text-xl font-semibold mt-8 mb-2">3. No Refund After Project Handover</h2>
      <p className="mb-4">Refunds will not be provided under the following conditions:</p>
      <ul className="list-disc list-inside ml-4 mb-4">
        <li>The client has received the finished project.</li>
        <li>Final deliverables have been approved by the client.</li>
        <li>Any part of the delivered work has been published, used, or deployed on a server or domain.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-2">4. How to Request a Refund</h2>
      <p className="mb-4">
        To request a refund, please email <a href="mailto:admin@racilasoftech.com" className="text-blue-600 underline">admin@racilasoftech.com</a> with:
      </p>
      <ul className="list-disc list-inside ml-4 mb-4">
        <li>Project ID</li>
        <li>Payment reference</li>
        <li>Reason for refund</li>
      </ul>
      <p className="mb-4">
        ✅ Ensure that the request is made within the allowed period. Approved refunds will be processed to your original payment method within 7–10 business days after our confirmation (we aim to respond within 5 business days).
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">5. Dispute Resolution</h2>
      <p className="mb-4">Refund-related matters will be handled internally by Racila Softech Pvt. Ltd. The decision of our management will be final.</p>

      <h2 className="text-xl font-semibold mt-8 mb-2">6. Updates to This Policy</h2>
      <p>This refund policy may be revised at any time. The latest version will always be available on our website.</p>

      <footer className="mt-16 border-t border-gray-700 pt-6">
  <div className="container mx-auto text-center text-gray-500">
    <p>&copy; 2025 Racila Softech. All rights reserved.</p>
    <div className="mt-4 flex justify-center space-x-6">
      <button
        onClick={() => window.open("/privacy-policy", "_blank")}
        className="text-sm text-blue-500 hover:text-blue-600 underline"
      >
        Privacy Policy
      </button>
      <button
        onClick={() => window.open("/refund-policy", "_blank")}
        className="text-sm text-blue-500 hover:text-blue-600 underline"
      >
        Refund Policy
      </button>
      <button
        onClick={() => window.open("/terms-conditions", "_blank")}
        className="text-sm text-blue-500 hover:text-blue-600 underline"
      >
        Terms & Conditions
      </button>
    </div>
  </div>
</footer>

    </section>
  );
};

export default RefundPolicy;
    